import { Box, Button, Stack, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import check from '@/assets/images/svg/check-icon.svg';
import { BaseDialog } from '@/components/shared/base-dialog';
import { clientKeys } from '@/data/@clients/client-keys';

interface RefundRequestCreatedDialogProps {
  onClose: () => void;
}

export const RefundRequestCreatedDialog = ({
  onClose,
}: RefundRequestCreatedDialogProps) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleClose = () => {
    queryClient.refetchQueries({
      queryKey: [clientKeys.useResourceApprovalsIndex],
    });
    queryClient.refetchQueries({
      queryKey: [clientKeys.useResourceApprovalShow],
    });
    navigate('/meus-reembolsos');
    onClose();
  };

  return (
    <BaseDialog
      open
      onClose={handleClose}
      icon={<Box component="img" src={check} sx={{ width: 55 }} />}
      title="Os comprovantes foram enviados!"
      actionsComponent={
        <Button variant="contained" onClick={handleClose}>
          Fechar
        </Button>
      }
    >
      <Stack spacing={2}>
        <Typography>
          Agora é só aguardar enquanto fazemos a conferência dos documentos e
          informações enviadas.
        </Typography>
        <Typography>
          Assim que tivermos a resposta enviaremos um email informando. Você
          também pode conferir o andamento na página de reembolsos.
        </Typography>
      </Stack>
    </BaseDialog>
  );
};
